import { FiltersTypes } from "@common/types/filters/general";
import { parseDateOnly } from "@design-system/DatePicker/DatePicker.lib";
import { resolveWorkDatePreset } from "@components/pageHeader/filters/Tabs/WorkDeliveryDateFilter/workDeliveryDatePresets";

interface ApplyWorkDeliveryDatePresetParams {
    filters: FiltersTypes;
    today: string;
}

/** Replaces the stored Work end dates with the preset's range, when there is one. */
export function applyWorkDeliveryDatePreset({
    filters,
    today,
}: ApplyWorkDeliveryDatePresetParams): FiltersTypes {
    const preset = filters.workDeliveryDatePreset;
    if (!preset) {
        return filters;
    }
    const { from, to } = resolveWorkDatePreset({ preset, today });
    return {
        ...filters,
        workDeliveryDateStart: parseDateOnly(from),
        workDeliveryDateEnd: parseDateOnly(to),
    };
}
